import { DateTime } from 'luxon';

export const BIRTH_DAY_MASK = '##.##.####';
export const BIRTH_DAY_FORMAT = 'dd.MM.yyyy';

export function parseBirthDay(value: string) {
  const digits = value.replace(/\D/gu, '');

  if (digits.length !== 8) {
    return null;
  }

  const date = DateTime.fromFormat(`${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`, BIRTH_DAY_FORMAT);

  return date.isValid ? date : null;
}

export function resolvePartialBirthDay(value: string, now: DateTime = DateTime.now().startOf('day')) {
  const digits = value.replace(/\D/gu, '');

  if (digits.length < 2) {
    return null;
  }

  const day = Number(digits.slice(0, 2));

  if (day < 1 || day > 31) {
    return null;
  }

  let month = now.toFormat('MM');
  let year = now.toFormat('yyyy');

  if (digits.length >= 4) {
    const parsedMonth = Number(digits.slice(2, 4));

    if (parsedMonth < 1 || parsedMonth > 12) {
      return null;
    }

    month = String(parsedMonth).padStart(2, '0');
  }

  if (digits.length > 4) {
    const parsedYear = Number(digits.slice(4, 8).padEnd(4, '0'));

    if (parsedYear < 1) {
      return null;
    }

    year = String(parsedYear).padStart(4, '0');
  }

  const monthStart = DateTime.fromFormat(`01.${month}.${year}`, BIRTH_DAY_FORMAT);

  if (!monthStart.isValid) {
    return null;
  }

  const safeDay = String(Math.min(day, monthStart.daysInMonth)).padStart(2, '0');
  const date = DateTime.fromFormat(`${safeDay}.${month}.${year}`, BIRTH_DAY_FORMAT);

  return date.isValid ? date.startOf('day') : null;
}

export function sqlDateToDisplay(value: string | null) {
  if (!value) {
    return '';
  }

  const sqlDate = DateTime.fromSQL(value);

  if (sqlDate.isValid) {
    return sqlDate.toFormat(BIRTH_DAY_FORMAT);
  }

  const displayDate = DateTime.fromFormat(value, BIRTH_DAY_FORMAT);
  return displayDate.isValid ? value : '';
}

export function displayDateToSql(value: string) {
  return parseBirthDay(value)?.toSQLDate() ?? null;
}
